export const categories = [
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    icon: 'ri-emotion-laugh-line',
    description: '最新明星动态、娱乐圈八卦爆料，带你第一时间了解圈内大小事',
    count: 128,
  },
  {
    slug: 'mingxing-neimu',
    name: '明星内幕',
    icon: 'ri-star-line',
    description: '明星幕后故事、不为人知的秘闻，深度揭秘娱乐圈内幕',
    count: 96,
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    icon: 'ri-fire-line',
    description: '社会热点事件追踪，聚焦全网热议话题，实时跟进事件进展',
    count: 87,
  },
  {
    slug: 'dujia-baoliao',
    name: '独家爆料',
    icon: 'ri-spy-line',
    description: '独家一手爆料，最劲爆的瓜等你来吃，全网独家内容',
    count: 64,
  },
  {
    slug: 'wangluo-reyi',
    name: '网络热议',
    icon: 'ri-chat-smile-2-line',
    description: '网络热门话题讨论，微博热搜、抖音热点、各大平台热议内容',
    count: 112,
  },
  {
    slug: 'zongyi-jumu',
    name: '综艺剧透',
    icon: 'ri-tv-line',
    description: '综艺节目独家剧透、录制花絮、选手内幕，综艺爱好者必看',
    count: 53,
  },
  {
    slug: 'shipin-gua',
    name: '视频吃瓜',
    icon: 'ri-video-line',
    description: '视频形式呈现最新瓜料，边看边吃更带劲，高清实拍一手素材',
    count: 41,
  },
  {
    slug: 'lishi-jiuigua',
    name: '历史旧瓜',
    icon: 'ri-history-line',
    description: '经典老瓜回顾，那些年我们吃过的瓜，重温娱乐圈经典事件',
    count: 35,
  },
];